import React from "react";

const styles = {
  container: {
    minHeight: "100vh",
    background: "#e8f2f7",
    backgroundImage: 'url("/assets/Images/SLUDI-background.png")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    overflow: "auto",
  },
  content: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  inner: {
    position: "relative",
    width: "100%",
    maxWidth: "500px",
  },
};

export default function MobileShell({ children }) {
  return (
    <div style={styles.container}>
      <div style={styles.headerStrip} />
      <div style={styles.content}>
        <div style={styles.inner}>{children}</div>
      </div>
    </div>
  );
}